import config from 'config';

import { GeoLocation } from '@/types/schema';

import { PlaceSuggestion } from '../types';

export const adaptPlacePredictions = (
  predictions: google.maps.places.AutocompletePrediction[],
): PlaceSuggestion[] => {
  return predictions.reduce((result, prediction) => {
    if (
      prediction.place_id &&
      (prediction.structured_formatting?.main_text ||
        prediction.structured_formatting?.secondary_text)
    )
      result.push({
        id: prediction.place_id,
        name:
          prediction.structured_formatting?.main_text ||
          prediction.structured_formatting?.secondary_text,
        description: prediction.structured_formatting?.main_text
          ? prediction.structured_formatting?.secondary_text
          : null,
      });

    return result;
  }, [] as PlaceSuggestion[]);
};

export const getGMapsLibraryUrl = () =>
  `https://maps.googleapis.com/maps/api/js?key=${config.google.maps_api_key}&libraries=places`;

export const getGeoLocationMapUrl = (geoLocation?: GeoLocation) => {
  if (!geoLocation?.latitude || !geoLocation?.longitude) {
    return null;
  }

  return `https://www.google.com/maps/search/?api=1&query=${geoLocation.latitude},${geoLocation.longitude}`;
};
